import React, { useEffect, useState } from "react";

const ProgressBar = ({ onFinish }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const target = 100;
    const duration = 5000; // 5 seconds
    const steps = 100;
    const increment = target / steps;
    const intervalTime = duration / steps;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev + increment >= target) {
          clearInterval(interval);

          setTimeout(() => {
            onFinish(); // ✅ safe to use here now
          }, 300);

          return target;
        }
        return prev + increment;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [onFinish]); // ✅ include it here

  return (
    <div className="progress-bar-2">
      <div className="filled" style={{ width: `${progress}%` }} />
    </div>
  );
};

export default ProgressBar;
